import { render, staticRenderFns } from "./SchoolFilters.vue?vue&type=template&id=3e45530e&"
import script from "./SchoolFilters.vue?vue&type=script&lang=js&"
export * from "./SchoolFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports